<template>
  <div class="main-view application-choice-page">
    <client-financing-offer-pop-up :show="showPdf" :mortgage-applications="mortgageApplications" :mortgage="mortgage"/>
    <handlers-wrapper-button :floating-handlers="floatingHandler" :handlers="getHandlers()"/>
    <div class="div-block-30 applicants-strip">
      <choice-user-detail-item
        :mortgage-id="mortgage.id"
        :client="applicant"
        :client-info="getApplicantInfo()"
        :co-applicant-present="!!coApplicant"
        :missing-info="missingInformation"
        compact
      />
      <choice-user-detail-item
        :mortgage-id="mortgage.id"
        :client="coApplicant"
        :client-info="getCoApplicantInfo()"
        :co-applicant-present="!!coApplicant"
        :missing-info="missingInformation"
        compact
      />
    </div>
    <div
      class="empty-bag-wrapper"
      v-if="missingInformation"
    >
      <img src="@/images/default-page.choices.png" width="200" height="175" alt="">
      <div style="max-width: 35%">
      <span class="txt-center">
        Zatiaľ tu nič nie je, prvé vypočítané ponuky sa tu zobrazia po doplnení <span
        v-html="missingInformationStatement"/>
      </span>
      </div>
    </div>
    <div
      class="div-block-105"
      v-if="limitsLoader && !missingInformation"
    >
      <div class="property-priority-row">
        <founded-property :mortgage-id="mortgage.id"/>
      </div>
      <section class="loan-purpose-section">
        <div class="loan-purpose-section-heading">
          <div>
            <div class="loan-purpose-title">Rozdelenie úveru podľa účelu</div>
            <div class="loan-purpose-description">Každý stĺpec predstavuje samostatný účel financovania.</div>
          </div>
          <div class="loan-purpose-total">
            <span>Požadovaný úver spolu</span>
            <strong>{{ totalRequestedAmount | dotTheAmount }} EUR</strong>
          </div>
        </div>
        <div class="loan-purpose-grid">
          <div class="loan-purpose-card amount-acquisition">
            <div class="purpose-card-heading">
              <span class="purpose-number">01</span>
              <div>
                <div class="purpose-name">Nadobudnutie</div>
                <div class="purpose-description">Kúpa alebo výstavba nehnuteľnosti</div>
              </div>
            </div>
            <nadobudnutie-wrapper :mortgage="mortgage" :total-limit="maxLimit" :loan-purpose="loanPurpose"/>
          </div>
          <div class="loan-purpose-card amount-refinancing">
            <div class="purpose-card-heading">
              <span class="purpose-number">02</span>
              <div>
                <div class="purpose-name">Refinancovanie</div>
                <div class="purpose-description">Splatenie existujúcich úverov</div>
              </div>
            </div>
            <refinancovanie-wrapper :mortgage="mortgage"
                                    :total-limit="maxLimit"
                                    :loan-purpose="loanPurpose"
                                    :clients-info="{applicantInfo: getApplicantInfo(), coApplicantInfo: getCoApplicantInfo()}"/>
          </div>
          <div class="loan-purpose-card amount-unrestricted">
            <div class="purpose-card-heading">
              <span class="purpose-number">03</span>
              <div>
                <div class="purpose-name">Bezúčelová časť</div>
                <div class="purpose-description">Doplnková časť bez dokladovania účelu</div>
              </div>
            </div>
            <ucelova-cast-wrapper :mortgage="mortgage" :total-limit="maxLimit" :loan-purpose="loanPurpose"/>
          </div>
        </div>
      </section>
        <!-- <div class="div-block-102">  
          <range-slider
            @change-event="setMortgageValue($event, 'own_funds')"
            :id-not-selected="'not-selected-vlastne-prostriedky'"
            :id-selected="'selected-vlastne-prostriedky'"
            :min="0"
            :max="maxLimit"
            :default-value="mortgage.own_funds ? mortgage.own_funds : 0"
            :twoSideValues="false"
            :description="'Vlastné prostriedky'"
            :unit="'EUR'"
            :value-correction="null"
            />
        </div> -->
      <mortgage-applications-choice-wrapper class="offers-results" :mortgage="mortgage" :mortgage-offers="mortgageApplications"/>
    </div>
    <div class="limits-loader" v-if="!limitsLoader && !missingInformation">
      <img class="image-limits-loading" src="@/images/limits-loader.png" alt="">
      <span class="blc-color MGright20px">prepočítavame limity na nastavenie požadovanej výšky úveru</span>
      <v-progress-circular
        class="loading-spinner small transparent"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import BonitaOfApplicants
  from "../../../../components/broker/KartaHypoteky/KartaHypotekyDetail/ApplicationChoice/BonitaOfApplicants";
import FoundedProperty
  from "../../../../components/broker/KartaHypoteky/KartaHypotekyDetail/ApplicationChoice/FoundedProperty";
import ChoiceUserDetailItem
  from "../../../../components/broker/KartaHypoteky/KartaHypotekyDetail/ApplicationChoice/ChoiceUserDetailItem";
import MortgageApplicationsChoiceWrapper
  from "../../../../components/broker/KartaHypoteky/KartaHypotekyDetail/ApplicationChoice/MortgageApplicationsChoiceWrapper";
import RangeSlider from "../../../../components/shared/RangeSlider";
import RefinancovanieWrapper
  from "../../../../components/broker/KartaHypoteky/KartaHypotekyDetail/ApplicationChoice/RefinancovanieWrapper";
import NadobudnutieWrapper
  from "../../../../components/broker/KartaHypoteky/KartaHypotekyDetail/ApplicationChoice/NadobudnutieWrapper";
import UcelovaCastWrapper
  from "../../../../components/broker/KartaHypoteky/KartaHypotekyDetail/ApplicationChoice/UcelovaCastWrapper";
import { mapGetters } from "vuex";
import HandlersWrapperButton from "../../../../components/shared/PopupHandler/HandlerWrapper/HandlersWrapperButton";
import mortgageUtils from "../../../../mixins/mortgageUtils";
import ClientFinancingOfferPopUp
  from "@/components/shared/PopupHandler/Popups/ClientFinnancingOffer/ClientFinancingOfferPopUp.vue";
const {getMortgagePurpose} = require("@/utils/mortgagePurpose");
const {getBestNonNegativeLoanLimit} = require("@/utils/loanLimit");

export default {
  name: "ApplicationChoice",
  components: {
    ClientFinancingOfferPopUp,
    HandlersWrapperButton,
    UcelovaCastWrapper,
    BonitaOfApplicants,
    FoundedProperty,
    ChoiceUserDetailItem,
    MortgageApplicationsChoiceWrapper,
    RangeSlider,
    RefinancovanieWrapper,
    NadobudnutieWrapper,
  },
  computed: {
    totalRequestedAmount () {
      return Object.values(this.amountsGetter || {}).reduce((total, amount) => total + Number(amount || 0), 0);
    },
    limitsLoader () {
      return this.$store.getters["appState/getLimitsLoader"];
    },
    ...mapGetters({
      mortgageOffersGetter: "mortgageDetailState/getOffers",
      clientFinancingOffersGetter: "popupManagerState/getClientFinancingOffersPopup",
      limitsGetter: "mortgageDetailState/getLimits",
      limitsChanged: "mortgageDetailState/getLimitsChanged",
      amountsGetter: "mortgageDetailState/getAmounts",
      coApplicantIncomes: "mortgageDetailState/getCoApplicantIncomes",
      applicantIncomes: "mortgageDetailState/getApplicantIncomes",
      limitCorrection: "mortgageDetailState/getLimitCorrection",
    }),
  },
  mixins: [
    mortgageUtils
  ],
  props: {
    mortgage: [Object, null],
    applicant: [Object, null],
    coApplicant: [Object, null],
  },
  async created () {
    this.checkForApplicantsMissingInfo();
    if (this.missingInformation) {
      this.refreshMissingInfo();
      return;
    }
    this.setLoanPurpose();
    const newLimits = this.$store.getters["mortgageDetailState/getLimits"];
    this.setUpperLimitLoanInfo(newLimits);
    const amounts = this.$store.getters["mortgageDetailState/getAmounts"];
    if (this.areAmountsZero(amounts)) {
      const mortgagePurpose = this.getMortgagePurpose();
      this.$store.commit("mortgageDetailState/setAmount", {
        type: `suma_${mortgagePurpose}`,
        value: this.maxLimit ? this.maxLimit : 0,
      })
    }
    await this.$store.dispatch("mortgageDetailState/fetchOffers");
    this.mortgageApplications = this.$store.getters["mortgageDetailState/getOffers"];
  },
  watch: {
    limitCorrection (correction) {
      this.maxLimit += correction;
    },
    async missingInformation(newValue, oldValue) {
      if (!newValue && oldValue) {
        const amounts = this.$store.getters["mortgageDetailState/getAmounts"];
        await this.waitUntilLimitsFilled();
        if (this.amountsAreZero(amounts) && this.maxLimit) {
          this.$store.commit("mortgageDetailState/setAmounts", {
            suma_nadobudnutie: this.maxLimit,
            suma_refinancovanie: 0,
            suma_bezucel: 0,
          });
          this.$store.dispatch("mortgageDetailState/fetchOffers", this.mortgage.id);
        }
      }
    },
    limitsChanged (limitsChange) {
      if (!limitsChange) this.floatingHandler = [];
      else this.floatingHandler = [{component: "LimitsRefreshButton"}];
    },
    mortgageOffersGetter (newApplications) {
      this.mortgageApplications = newApplications;
    },
    clientFinancingOffersGetter(show) {
      this.showPdf = show;
    },
    coApplicantIncomes () {
      this.refreshMissingInfo();
    },
    applicantIncomes () {
      this.refreshMissingInfo();
    },
    // mortgage () {
    //   if (this.missingInformation) return;
    //   // this.$store.dispatch("mortgageDetailState/fetchOffers", newMortgage.id);
    //   // this.$store.dispatch("mortgageDetailState/fetchLimits", newMortgage.id);
    // },
    applicant () {
      this.refreshMissingInfo();
    },
    coApplicant () {
      this.refreshMissingInfo();
    },
    limitsGetter (newLimits) {
      if (!this.missingInformation) {
        this.setLoanPurpose();
        this.setUpperLimitLoanInfo(newLimits);
        const amounts = this.$store.getters["mortgageDetailState/getAmounts"];
        if (this.amountsAreZero(amounts) && this.maxLimit > 0) {
          this.$store.commit("mortgageDetailState/setAmount", {
            type: `suma_${this.getMortgagePurpose()}`,
            value: this.maxLimit,
          });
        }
        this.$store.dispatch("mortgageDetailState/fetchOffers");
      }
    },
  },
  methods: {
    a() {
      this.$store.commit("mortgageDetailState/setLimitsChanged", true);
    },
    waitUntilLimitsFilled () {
      return new Promise((resolve) => {
        let counter = 0;
        const int = setInterval(() => {
          if (this.maxLimit) {
            clearInterval(int);
            resolve(true);
          } else {
            counter++;
          }
          if (counter > 100) {
            clearInterval(int);
            resolve(false);
          }
        }, 100);
      });
    },
    areAmountsZero(object) {
      return object.suma_bezucel === 0 && object.suma_nadobudnutie === 0 && object.suma_refinancovanie === 0;
    },
    getHandlers () {
      return [
        {
          component: "DocumentCloudHandler",
          classCst: "button-item-handler white&#45;&#45;text no-decoration",
          iconButton: true,
          rules: ['single'],
          cloudMeta: this.$store.getters["mortgageDetailCloud/getFullClouds"],
        },
        {
          component: "CalculationsHistoryHandler",
          history: this.mortgage.offers_filter_history,
          rules: ['priority'],
        },
        {
          component: "ClientFinancingOfferHandler",
          rules: ['priority'],
        },
        {
          component: "MetodicTable",
          rules: ['priority'],
        }
      ]
    },
    refreshMissingInfo () {
      this.checkForApplicantsMissingInfo();
      if (!this.missingInformation) {
        // this.$store.dispatch("mortgageDetailState/fetchOffers", this.mortgage.id);
        // this.$store.dispatch("mortgageDetailState/fetchLimits", this.mortgage.id);
      } else {
        this.updateMissingStatementInfo();
      }
    },
    // upravene cez chatgpt aby nebol pozadavany prijem spoluziadatela
    updateMissingStatementInfo () {
      this.missingInformationStatement = "";
      const ap = this.missingInformationData.applicant;
      const coap = this.missingInformationData.coApplicant;

      // Kontrola pre žiadateľa
      if (!ap.income && !ap.bonita) {
        this.missingInformationStatement += "aspoň <strong>jedného príjmu a bonity žiadateľa</strong>";
      } else if (!ap.income) {
        this.missingInformationStatement += "aspoň <strong>jedného príjmu žiadateľa</strong>";
      } else if (!ap.bonita) {
        this.missingInformationStatement += "<strong>bonity žiadateľa</strong>";
      }

      // Ak nie je spolužiadateľ, skonči
      if (!this.coApplicant) return;

      // Kontrola pre spolužiadateľa (príjem už nie je povinný)
      if (!coap.bonita) {
        this.missingInformationStatement += " a <strong>bonity spolužiadateľa</strong>";
      }
    },

    checkForApplicantsMissingInfo () {
      let isMissing = false;
      const applicant = {
        income: true,
        bonita: true,
      };
      const coApplicant = {
        income: true,
        bonita: true,
      }
      if (this.applicant) {
        if (this.$store.getters["mortgageDetailState/getClientIncomes"]('applicant').length === 0) {
          applicant.income = false;
          this.missingInformation = true;
          isMissing = true;
        }
        const cp = this.applicant.client_profile
        // console.log(this.applicant);
        if (!cp.vek_v_case_vyplnania && !cp.datum_narodenia) {
          applicant.bonita = false;
          this.missingInformation = true;
          isMissing = true;
        }
      }
      if (this.coApplicant) {
        const cp = this.coApplicant.client_profile;
        if (!cp.vek_v_case_vyplnania && !cp.datum_narodenia) {
          coApplicant.bonita = false;
          this.missingInformation = true;
          isMissing = true;
        }
        // NEKONTROLUJ príjem spolužiadateľa
      }

      this.missingInformationData = {applicant, coApplicant};
      if (!isMissing) this.missingInformation = false;
    },
    amountsAreZero(amounts) {
      for (const amount of Object.values(amounts)) {
        if (amount === 0) continue;
        return false;
      }
      return true;
    },
    checkIfLimitIsEnough (maxLimit) {
      const amounts = this.$store.getters["mortgageDetailState/getAmounts"];
      let currentAmount = 0;
      for (const amount of Object.values(amounts)) {
        currentAmount += amount;
      }
      let excessAmount = currentAmount - maxLimit;
      return excessAmount <= 0;
    },
    setUpperLimitLoanInfo (limits) {
      if (!limits) return;
      const {maxLimit, bankLoan} = getBestNonNegativeLoanLimit(limits, this.loanPurpose);
      this.$store.commit(
        "mortgageDetailState/setLoanLimit",
        bankLoan !== null ? Math.floor(maxLimit) : 0,
      );
      if (!this.checkIfLimitIsEnough(maxLimit)) {
        this.maxLimit = Math.floor(maxLimit);
        const purpose = `suma_${this.getMortgagePurpose()}`;
        const amountsObject = {
          suma_refinancovanie: 0,
          suma_bezucel: 0,
          suma_nadobudnutie: 0,
        };
        amountsObject[purpose] = this.maxLimit;
        this.$store.commit("mortgageDetailState/setAmounts", amountsObject);
        this.$store.commit("appState/setSuccessMessage", {
          text: "Suma hypotéky presahovala limity, bola nastavená maximálna výška úveru podľa typu hypotéky",
          type: "error"
        });
      } else {
        if (bankLoan !== null) {
          this.maxLimit = Math.floor(maxLimit);
        } else {
          this.$store.commit("mortgageDetailState/nullAmounts");
          this.maxLimit = 0;
        }
      }
      // console.log("Splatnosť ", bankDue, this.maxDue);
      // console.log("Úver ", bankLoan, this.maxLimit);
    },
    // setDefaultApplicationsData () {
    //   const appData = this.$store.getters["mortgageDetailState/getApplicationsData"];
    //   this.$store.commit("mortgageDetailState/setApplicationsData", {
    //     maximalna_splatnost: this.maxDue,
    //     splatnost_v_rokoch: this.maxDueRelated,
    //     fix: appData.fix,
    //   })
    // },
    setLoanPurpose () {
      const amounts = this.$store.getters["mortgageDetailState/getAmounts"];
      const properties = this.$store.getters["mortgageDetailState/getProperties"];
      this.loanPurpose = getMortgagePurpose(amounts, this.mortgage.ciel_prva_analyza, {
        forceAcquisition: (properties?.financedPropertiesIds || []).length > 0,
      });
    },
    setMortgageValue (value, field) {
      const mortgage = {
        id: this.mortgage.id,
        object: {},
      }
      mortgage.object[field] = value;
      this.$store.dispatch("mortgageDetailState/patchMortgage", mortgage);
    },
    getApplicantInfo () {
      return {
        type: "Žiadateľ",
        type_code: "applicant",
        id: this.applicant.id,
        firstName: this.applicant.first_name,
        lastName: this.applicant.last_name,
        age: this.getClientAge(this.applicant),
      };
    },
    getCoApplicantInfo () {
      if (!this.coApplicant) return {
        type: "Spolužiadateľ",
        type_code: "coApplicant",
        id: null,
        firstName: null,
        lastName: null,
        age: null,
      };
      return {
        type: "Spolužiadateľ",
        type_code: "coApplicant",
        id: this.coApplicant.id,
        firstName: this.coApplicant.first_name,
        lastName: this.coApplicant.last_name,
        age: this.getClientAge(this.coApplicant),
      };
    },
    getClientAge (client) {
      const profile = client?.client_profile;
      if (Number(profile?.vek_v_case_vyplnania) > 0) {
        return Number(profile.vek_v_case_vyplnania);
      }
      if (!profile?.datum_narodenia) return null;

      const birthDate = new Date(profile.datum_narodenia);
      if (Number.isNaN(birthDate.getTime())) return null;
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const birthdayThisYear = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
      if (today < birthdayThisYear) age -= 1;
      return age;
    },
  },
  data: () => ({
    firstTime: true,
    floatingHandler: [],
    pdfFile: "/document.pdf",
    mortgageApplications: null,
    showPdf: false,
    i: 0,
    limits: null,
    maxLimit: null,
    maxDue: null,
    maxDueRelated: null,
    loanPurpose: null,
    missingInformationStatement: "",
    missingInformationData: null,
    missingInformation: false,
  }),
};
</script>

<style lang="scss" scoped>

.main-view {
  grid-template-columns: minmax(0, 1fr);
}

.applicants-strip {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  min-width: 0;
}

.div-block-105 {
  grid-template-columns: minmax(0, 1fr);
  grid-template-areas:
    "Property"
    "Purposes"
    "Area";
}

.property-priority-row {
  grid-area: Property;
  min-width: 0;
}

.loan-purpose-section {
  box-sizing: border-box;
  grid-area: Purposes;
  min-width: 0;
  padding: 18px;
  border: 1px solid var(--app-border);
  border-radius: 16px;
  background: color-mix(in srgb, var(--app-surface) 48%, transparent);
}

.loan-purpose-section-heading {
  display: flex;
  min-width: 0;
  margin-bottom: 14px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.loan-purpose-title {
  color: var(--app-text);
  font-size: 15px;
  font-weight: 900;
}

.loan-purpose-description,
.purpose-description {
  margin-top: 2px;
  color: var(--app-text-muted);
  font-size: 10px;
}

.loan-purpose-total {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-end;
  padding: 8px 12px;
  border-radius: 11px;
  border: 1px solid var(--app-border);
  background: var(--app-surface-muted);
  color: var(--app-text-muted);
  font-size: 9px;
}

.loan-purpose-total strong {
  margin-top: 2px;
  color: var(--app-text);
  font-size: 13px;
}

.loan-purpose-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  min-width: 0;
}

.loan-purpose-card {
  display: flex;
  box-sizing: border-box;
  height: 100%;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--app-border);
  border-radius: 14px;
  background: var(--app-surface);
  box-shadow: none;
}

.loan-purpose-card > div:last-child {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
}

.purpose-card-heading {
  display: flex;
  padding: 14px 16px 0;
  align-items: center;
  gap: 9px;
}

.purpose-number {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: var(--app-primary-soft);
  color: var(--app-primary);
  font-size: 9px;
  font-weight: 900;
}

.purpose-name {
  color: var(--app-text);
  font-size: 12px;
  font-weight: 900;
}

.loan-purpose-card ::v-deep .div-block-102 {
  height: 100%;
  min-height: 100%;
  margin-bottom: 0;
  border-radius: 0;
  background: transparent !important;
  box-shadow: none !important;
}

.offers-results {
  grid-area: Area;
  padding-right: 0;
  padding-left: 0;
}

.empty-bag-wrapper {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column
}

@media screen and (max-width: 991px) {
  .applicants-strip {
    grid-template-columns: minmax(0, 1fr);
  }

  .div-block-105 {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas:
      "Property"
      "Purposes"
      "Area";
  }

  .loan-purpose-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media screen and (max-width: 767px) {
  .loan-purpose-section-heading {
    align-items: stretch;
    flex-direction: column;
  }

  .loan-purpose-total {
    align-items: flex-start;
  }
}

</style>
